/*
 * nomad-bundle-add.js
 *
 * Capture-phase click interceptor on the product form's submit button.
 * When the user has selected a chain or enabled engraving, builds an
 * items[] array containing the pendant + optional engraving variant +
 * optional chain variant and POSTs them in a single /cart/add.js call.
 * Falls through to Dawn's default single-item submit when no add-ons
 * are active.
 */

(function () {
  if (window.__nomadBundleAddInit) return;
  window.__nomadBundleAddInit = true;

  function getChainState() {
    var wrap = document.querySelector('[data-nomad-chain-selector]');
    if (!wrap) return null;
    var vidInput = wrap.querySelector('[data-chain-prop="variant_id"]');
    var titleInput = wrap.querySelector('[data-chain-prop="title"]');
    var priceInput = wrap.querySelector('[data-chain-prop="price"]');
    return {
      wrap: wrap,
      variantId: vidInput && vidInput.value,
      reset: function () {
        if (vidInput) vidInput.value = '';
        if (titleInput) titleInput.value = '';
        if (priceInput) priceInput.value = '';
        var cards = wrap.querySelectorAll('.nomad-chain-card');
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        var noChain = wrap.querySelector('[data-no-chain]');
        if (noChain) noChain.classList.add('is-selected');
      },
    };
  }

  function getEngravingState() {
    var wrap = document.querySelector('[data-nomad-engraving]');
    if (!wrap) return null;
    var toggle = wrap.querySelector('[data-engraving-toggle]');
    return {
      wrap: wrap,
      toggle: toggle,
      enabled: !!(toggle && toggle.checked),
      variantId: wrap.getAttribute('data-engraving-variant-id'),
      reset: function () {
        if (toggle && toggle.checked) {
          toggle.checked = false;
          toggle.dispatchEvent(new Event('change'));
        }
      },
    };
  }

  function attach() {
    var productForm = document.querySelector('product-form');
    if (!productForm) {
      setTimeout(attach, 200);
      return;
    }
    var form = productForm.querySelector('form');
    var submitBtn = productForm.querySelector('[type="submit"]');
    if (!form || !submitBtn || submitBtn.dataset.nomadBundled) return;
    submitBtn.dataset.nomadBundled = '1';

    submitBtn.addEventListener('click', function (e) {
      var chain = getChainState();
      var engraving = getEngravingState();
      var hasChain = !!(chain && chain.variantId);
      var hasEngraving = !!(engraving && engraving.enabled && engraving.variantId);

      if (!hasChain && !hasEngraving) return; // Dawn handles plain pendant
      if (submitBtn.getAttribute('aria-disabled') === 'true') return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var spinner = productForm.querySelector('.loading__spinner');
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      var fd = new FormData(form);
      var mainId = parseInt(fd.get('id'), 10);
      var qty = parseInt(fd.get('quantity') || '1', 10);

      // Split form properties into pendant vs engraving
      var pendantProps = {};
      var engravingProps = {};
      var entries = Array.from(fd.entries());
      for (var i = 0; i < entries.length; i++) {
        var key = entries[i][0];
        var val = entries[i][1];
        var m = key.match(/^properties\[(.+)\]$/);
        if (!m || !val) continue;
        var propName = m[1];
        if (propName.indexOf('_chain_') === 0) continue;
        if (propName.indexOf('_engraving_') === 0) {
          engravingProps[propName] = val;
        } else {
          pendantProps[propName] = val;
        }
      }

      var titleEl = document.querySelector('.product__title h1') || document.querySelector('.product__title');
      var mainTitle = titleEl ? titleEl.innerText.trim() : 'Pendant';

      var items = [{ id: mainId, quantity: qty, properties: pendantProps }];

      if (hasEngraving) {
        engravingProps['_for_pendant'] = mainTitle;
        items.push({
          id: parseInt(engraving.variantId, 10),
          quantity: qty,
          properties: engravingProps,
        });
      }

      if (hasChain) {
        items.push({
          id: parseInt(chain.variantId, 10),
          quantity: qty,
          properties: { '_bundled_with': mainTitle },
        });
      }

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sections = [];
      if (cart && typeof cart.getSectionsToRender === 'function') {
        sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      }

      var body = { items: items };
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = window.location.pathname;
      }

      if (cart && typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            if (window.publish && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainId,
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            console.error('[nomad bundle add]', response.message || response.description);
            return;
          }
          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainId,
              cartData: response,
            });
          }
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

          if (chain) chain.reset();
          if (engraving) engraving.reset();
        })
        .catch(function (err) {
          console.error('[nomad bundle add]', err);
        })
        .finally(function () {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }, true); // capture phase
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
